import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import NewsArticleContent from "./NewsArticleContent";

export default function NewsArticlePage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArticle();
  }, [slug]);

  const loadArticle = async () => {
    setLoading(true);

    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/News/article/${slug}`
    );

    if (!res.ok) {
      setLoading(false);
      return;
    }

    const data = await res.json();
    setArticle(data.article);
    setRelated(data.related || []);
    setLoading(false);
  };

  if (loading) return <div className="p-6 text-center">Chargement...</div>;
  if (!article)
    return <div className="p-6 text-center">Article introuvable</div>;

  return (
    <div className="w-full bg-[#FFF9E6]/40 pb-12">
      {/* BANDE LÉGÈRE QUI ENVELOPPE L’ARTICLE */}
      <div className="w-full  p-6">
        <button
          onClick={() => navigate(-1)}
          className="btn bg-primary text-white rounded-full flex items-center gap-2 ml-6 py-2 px-4"
        >
          <ArrowLeftIcon className="w-5 h-5" />
          Retour
        </button>
        <div className="max-w-5xl mx-auto px-4">
          <NewsArticleContent article={article} />
        </div>
      </div>

      {/* Articles liés */}
      {related.length > 0 && (
        <div className="w-full max-w-5xl mx-auto px-4 mt-14">
          <h2 className="text-xl text-primary font-bold mb-4">
            Regardez aussi…
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {related.map((item) => (
              <a
                key={item.id}
                href={`/actualites/${item.slug}`}
                className="border rounded-xl overflow-hidden shadow hover:shadow-md transition block"
              >
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-40 object-cover"
                />
                <div className="p-3">
                  <h3 className="font-semibold text-primary">{item.title}</h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
